import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { EstimateProvider } from "@/context/EstimateContext";
import { ProProvider } from "@/context/ProContext";
import Dashboard from "@/pages/Dashboard";
import ProjectDetail from "@/pages/ProjectDetail";
import Paywall from "@/pages/Paywall";
import Settings from "@/pages/Settings";

function App() {
  return (
    <ThemeProvider>
      <EstimateProvider>
        <ProProvider>
          <div className="min-h-screen bg-surface text-foreground">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/project/:id" element={<ProjectDetail />} />
                <Route path="/paywall" element={<Paywall />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </div>
        </ProProvider>
      </EstimateProvider>
    </ThemeProvider>
  );
}

export default App;
